import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';
import { TELEGRAM_SUPPORT_URL } from '../utils/constants';

export function ResellerPage() {
  const { t } = useTranslation();
  const blocks = useContentBlocks('staticPages.reseller.blocks');

  return (
    <StaticPageLayout titleKey="staticPages.reseller.title" subtitleKey="staticPages.reseller.subtitle">
      <ContentSections blocks={blocks} />
      <div className="mt-6 flex flex-wrap gap-3">
        <Link
          to="/register"
          className="inline-flex items-center justify-center h-11 px-5 rounded-full bg-brand-accent text-white font-heading font-semibold text-sm"
        >
          {t('staticPages.reseller.ctaRegister')}
        </Link>
        <a
          href={TELEGRAM_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center h-11 px-5 rounded-full border border-brand-accent/50 text-brand-accent font-heading font-semibold text-sm"
        >
          {t('staticPages.reseller.ctaSupport')}
        </a>
        <Link to="/login" className="inline-flex items-center justify-center h-11 px-5 text-sm font-heading font-semibold text-brand-accent">
          {t('staticPages.reseller.ctaLogin')}
        </Link>
      </div>
    </StaticPageLayout>
  );
}
